import { useCallback } from 'react';

import type { EventEmitterCatalog } from '@/clientState/hooks/events/eventCatalog';
import type { EventMessage } from '@/clientState/hooks/events/types';
import { getAllowedOrigin } from './utils';

export const useEventEmitter = <T>(
  id: EventEmitterCatalog,
  target?
): ((data?: T) => void) => {
  return useCallback(
    (data?: T) => {
      const targetWindow =
        document.querySelector('#payment-form-iframe') || target || window;
      const event: EventMessage<T> = { id, callbackData: data };
      if (targetWindow?.contentWindow) {
        targetWindow.contentWindow.postMessage(event, getAllowedOrigin());
      } else {
        targetWindow.postMessage(event, getAllowedOrigin());
      }
    },
    [id, target]
  );
};
